<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på land</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';

export default {
    name: 'CompanyFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: [
                {
                    id: 1,
                    label: 'Supékort Sweden AB',
                },
                {
                    id: 2,
                    label: 'Newport Collection AB',
                },
                {
                    id: 3,
                    label: 'Newport In & Exterior Downtown Aktiebolag',
                },
                {
                    id: 99,
                    label: 'Ej anställd / Extern',
                },
            ],
        };
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
